export const GET_USERS = `
query GetAllUser($input: TuserWhereInput, $skip: Float, $take: Float ){
  getUser(where: $input,skip: $skip, take: $take){
    pageInfo{
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items{
      id
      email
      fullName
      avatar
      phoneNumber
      isWorking
      role
      tteamSalesDetails{
        id
        tteamSales{
          id
          name
          tsalesPlannings{
            id
            route{
              id
            }
          }
        }
      }
    }
  }
}`;

export const GET_USERS_NOT_TEAM_SALE = `
query GetUser($input: TuserWhereInput, $skip: Float, $take: Float) {
  getUser(where: $input, skip: $skip, take: $take, orderBy:{createDate: DESC}) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
      id
      email
      fullName
      avatar
      phoneNumber
      isWorking
      role
      activeRoute
    }
  }
}`;

export const GET_ALL_USER = `query GetAllUser($input: TuserWhereInput, $skip: Float, $take: Float ){
    getUser(where: $input,skip: $skip, take: $take, orderBy:{createDate: DESC}){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
         items{
            id
            plantCode
            fullName
            email
            role
            employeeId
            trole{
                id
                name
            }
            jobTitleCode
            tjobtitle{
                id
                jobName
                trole{
                    id
                    name
                }
            }
            createDate
            modifyDate
        }
    }
}`;

export const UPDATE_USER_ROLE = `
mutation UpdateUser ($data: TuserInput!) {
  updateUser (input: $data) {
    id
    plantCode
    email
    fullName
    role
  }
}`;

export const GET_USER_ROLE_SALE_IN_CBB = `query GetAllUser($input: TuserWhereInput, $skip: Float, $take: Float ){
    getUser(where: $input,skip: $skip, take: $take, orderBy:{createDate: DESC}){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            email
            fullName
            avatar
            phoneNumber
            isWorking
            role
            plantCode
        }
    }
}
`;

export const GET_USER_BY_PLANT_EMAIL = `
  query GetUserByPlant($input: TuserWhereInput!, $skip: Float, $take: Float ){
      getUser(where: $input,skip: $skip, take: $take){
          pageInfo{
              currentPage
              hasNextPage
              hasPreviousPage
              itemsPerPage
              totalItems
              totalPages
          }
          items{
              id
              fullName
              email
              avatar
              plantCode
          }
      }
  }
`;
